import * as React from "react";
import { SVGProps } from "react";

const TheTransferToken = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106 95" {...props}>
    <path
      fill="#5569FF"
      d="M34.4 95.1h62.9l9.1-16.3H43.6zm60.9-36H77l-9.1 16.2h18.2z"
    />
    <path fill="#5C00E9" d="M95.3 55.6 63.9 0H45.6l31.5 55.6z" />
    <path
      fill="#00BFE9"
      d="m0 77.1 9.1 16.1 31.5-55.6-9.2-16.1zm31.4 16.1 9.2-16.1-9.2-16.2-9.1 16.2z"
    />
    <path fill="#5C00E9" d="m34.5 19.7 9.1 16.2h18.3l-9.2-16.2z" />
    <path
      fill="#243269"
      d="M106.4 75.3 98.3 61l-8.1 14.3zm-41.5-1.8L74 57.4l-9.1-16.2-9.2 16.2zM34.4 59.1l9.2 16.2h18.3l-9.2-16.2zm9.2-19.7-9.2 16.2h18.3l9.1-16.2zM12.1 95.1h16.3l-8.1-14.4zM42.6 1.8l-8.2 14.4h16.3z"
    />
  </svg>
);

export default TheTransferToken;
